import { render, staticRenderFns } from "./Entries.vue?vue&type=template&id=0bae059c&"
import script from "./Entries.vue?vue&type=script&lang=js&"
export * from "./Entries.vue?vue&type=script&lang=js&"
import style0 from "./Entries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bae059c')) {
      api.createRecord('0bae059c', component.options)
    } else {
      api.reload('0bae059c', component.options)
    }
    module.hot.accept("./Entries.vue?vue&type=template&id=0bae059c&", function () {
      api.rerender('0bae059c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/Entries.vue"
export default component.exports